import { Component, HostBinding, inject, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
	selector: "loading-indicator",
	templateUrl: "./loading-indicator.component.html",
	styleUrls: ["./loading-indicator.component.scss"],
	standalone: false,
})
export class LoadingIndicatorComponent {
	private sanitizer = inject(DomSanitizer);

	@HostBinding("style.margin-top") marginTop: any;
	@Input() running: boolean;
	@Input() color: string;

	private spinnerSize: number;

	@Input()
	set size(value: number) {
		this.spinnerSize = value;

		this.marginTop = this.sanitizer.bypassSecurityTrustStyle(`-${value / 2}px`);
	}

	get size() {
		return this.spinnerSize;
	}
}
